export default __webpack_public_path__ + "static/media/courier.26244d3b.svg";